import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-mua-chung-setting'

export const getMuaChungSetting = async (token) => {
    const response = await axios.get(`${host}/${PLUGINS_NAME}/get`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200 && response.data) {
        return {
            showMuaChung: response.data.showMuaChung ?? 1,
            userExpireDays: response.data.userExpireDays ?? 14,
            userMinContributePercent: response.data.userMinContributePercent ?? null,
            allowSamePlayMethod: response.data.allowSamePlayMethod ?? 1,
            maxOpenGroupsPerGame: response.data.maxOpenGroupsPerGame ?? 0,
        }
    }
    return {
        showMuaChung: 1,
        userExpireDays: 14,
        userMinContributePercent: null,
        allowSamePlayMethod: 1,
        maxOpenGroupsPerGame: 0,
    }
}

export const getShowMuaChung = async (token) => {
    const setting = await getMuaChungSetting(token)
    return setting.showMuaChung
}

export const updateShowMuaChung = async (token, showMuaChung) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        showMuaChung: showMuaChung
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data
    }
    return null
}

export const updateMuaChungUserExpireDays = async (token, userExpireDays) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        userExpireDays: userExpireDays
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data
    }
    return null
}

export const updateMuaChungAllowSamePlayMethod = async (token, allowSamePlayMethod) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        allowSamePlayMethod: allowSamePlayMethod
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data
    }
    return null
}

export const updateMuaChungMaxOpenGroupsPerGame = async (token, maxOpenGroupsPerGame) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        maxOpenGroupsPerGame: maxOpenGroupsPerGame
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data
    }
    return null
}

export const updateMuaChungUserMinContributePercent = async (token, userMinContributePercent) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        userMinContributePercent: userMinContributePercent
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data
    }
    return null
}
